import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { LocalizationProvider, DateTimePicker as XDateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ThemeProvider } from '@mui/material/styles';

import newTheme from '../../style/muiTheme';
import { Button } from '../Buttons/Button';
import './DatePickers.scss';
import { getColorsForColorTheme } from '../../utils/colorTheme';

export function CustomActions(props) {
  const { onAccept, onClear, onCancel, onSetToday, actions, className, add5MinutesToToday } = props;

  if (actions == null || actions.length === 0) {
    return null;
  }

  const actionItems = React.useMemo(() => {
    const items = [];
    actions.forEach(action => {
      switch (action) {
        case 'now':
          items.push({
            label: 'Now',
            onClick: () => {
              onSetToday();
              onAccept();
            },
          });
          break;
        case 'accept':
          items.push({
            label: 'OK',
            onClick: () => {
              onAccept();
            },
          });
          break;
        case 'cancel':
          items.push({
            label: 'Cancel',
            onClick: () => {
              onCancel();
              onAccept();
            },
          });
          break;
        case 'clear':
          items.push({
            label: 'Clear',
            onClick: () => {
              onClear();
              onAccept();
            },
          });
          break;
        case 'today':
          items.push({
            label: 'Today',
            onClick: () => {
              onSetToday();
              onAccept();
            },
          });
          break;
        case 'in5minutes':
          items.push({
            label: 'In 5 Minutes',
            onClick: () => {
              add5MinutesToToday();
              onAccept();
            },
          });
          break;
        default:
          break;
      }
    });
    return items;
  }, [actions, onAccept, onSetToday, onClear, onCancel, add5MinutesToToday]);

  return (
    <div className={className} style={{ padding: 8 }}>
      {actionItems.map(action => (
        <Button
          id={`${action.label.toLowerCase()}-button`}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
}

export default function DateTimePicker({
  value,
  className,
  showNowButton,
  timezone,
  views,
  onChange,
  actions = ['cancel', 'accept', 'now'],
  ...props
}) {
    const theme = React.useMemo(() => {
      if (!className?.includes('invalid-control-background')) {
        return newTheme(getColorsForColorTheme().mainColor);
      }
      const ret = cloneDeep(newTheme(getColorsForColorTheme().mainColor));
      ret.components.MuiTextField.styleOverrides.root.backgroundColor = 'rgba(218, 84, 125, 0.1)';
      return ret;
    }, [className]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
        <XDateTimePicker
          // viewRenderers={{
          //   hours: renderTimeViewClock,
          //   minutes: renderTimeViewClock,
          //   seconds: renderTimeViewClock,
          // }}
          value={value || null}
          onChange={onChange}
          timezone={timezone}
          views={views || ['year', 'month', 'day', 'hours', 'minutes']}
          formatDensity="spacious"
          closeOnSelect
          slots={{ actionBar: CustomActions }}
          slotProps={{
            field: { clearable: true },
            actionBar: { actions, onSetToday: () => {onChange(moment());}, add5MinutesToToday: () => {onChange(moment().add(5, 'minutes'));} },
          }}
          {...props}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
